import React, { Component } from 'react';
import './App.css';
import { AppBar, IconButton, RaisedButton, Avatar } from 'material-ui';
import { Route, Link } from 'react-router-dom';
import ActionHome from 'material-ui/svg-icons/action/home';
import ActionLockOutline from 'material-ui/svg-icons/action/lock-outline';
import { withRouter } from 'react-router-dom';
import firebase from '../util/fire';
import autobind from 'react-autobind';

import Home from './Home';
import Login from './Login';
import Planner from './Planner';
import PermissionDialog from './PermissionDialog';

const signOutUser = () => {
   firebase.auth().signOut();
};

const PermissionButton = ({ showDialog, match }) => <IconButton style={{ position: "relative", top: "-7px" }} onClick={() => showDialog(match.params.tripid)}><ActionLockOutline color="white" /></IconButton>;

const LoggedIn = ({ user, showDialog }) => (
   <div>
	   <Route path="/trip/:tripid" render={(props) => <PermissionButton {...props} showDialog={showDialog} />} />
	   <Avatar onClick={signOutUser} style={{ marginTop: '5px' }} src={user.image} />
   </div>
);

const LoginButton = () => (
   <Link to="/login"><RaisedButton style={{ marginTop: '5px' }} label="Login" /></Link>
);


class App extends Component {
   constructor(props) {
      super(props);
	   autobind(this);
      this.authStateChanged = this.authStateChanged.bind(this);
      this.state = {
      	user: null,
	      tripId: null,
	      permissionDialogVisible: false
      };
   }


   componentDidMount() {
	   firebase.auth().onAuthStateChanged(this.authStateChanged);
   }

   authStateChanged(user) {
      if(user) {
         this.setState({
            user: {
               uid: user.uid,
               email: user.email,
               image: user.photoURL,
               name: user.displayName
            }
         });
      } else {
         this.setState({
            user: null
         });
      }
   }

   showDialog(tripId) {
		this.setState({
			tripId,
			permissionDialogVisible: true
		});
   }

   hideDialog() {
   	this.setState({
		   tripId: null,
		   permissionDialogVisible: false
   	});
   }

	renderPermissionDialog() {
		if(!this.state.permissionDialogVisible) {
			return null;
		}

		return (<PermissionDialog tripId={this.state.tripId} hideDialog={this.hideDialog} />);
	}

	render() {
		return (
			<div>
				<AppBar
					title="Road Trip Planner"
					iconElementLeft={<IconButton><ActionHome/></IconButton>}
					iconElementRight={this.state.user ? <LoggedIn showDialog={this.showDialog} user={this.state.user} /> : <LoginButton />}
					onLeftIconButtonClick={() => this.props.history.push('/')}
				/>
				{this.renderPermissionDialog()}
				<div className="container" style={{ position: "absolute", top: "60px", bottom: 0 }}>
					<Route path="/trip/:tripid" component={Planner} />
					<Route path="/login" component={Login} />
					<Route exact path="/" component={Home} />
				</div>
			</div>
		);
	}
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js